import { haversineKm } from './haversine';

type Addr = { lat: number | null | undefined; lng: number | null | undefined };

/**
 * Given a partner's address list and an optional user location, return the
 * partner address closest to the user. If the user has no location, returns
 * the first address that has coordinates. Returns null when nothing usable
 * exists.
 */
export function findClosestPartnerLocation(
    addresses: ReadonlyArray<Addr>,
    userLocation: { lat: number; lng: number } | null,
): { lat: number; lng: number } | null {
    if (userLocation) {
        let best: { lat: number; lng: number } | null = null;
        let bestDist = Infinity;
        for (const addr of addresses) {
            if (addr.lat == null || addr.lng == null) continue;
            const d = haversineKm(userLocation, { lat: addr.lat, lng: addr.lng });
            if (d < bestDist) {
                bestDist = d;
                best = { lat: addr.lat, lng: addr.lng };
            }
        }
        return best;
    }
    for (const addr of addresses) {
        if (addr.lat != null && addr.lng != null) {
            return { lat: addr.lat, lng: addr.lng };
        }
    }
    return null;
}
